import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { colors } from '../../../utils/theme';
import { PortalHost } from '@gorhom/portal';

export type AudioRecordingContainerOwnProps = {
    style: StyleProp<ViewStyle>;
    children: React.ReactNode;
};

export type AudioRecordingContextProps = {
    isRecorderOpen: boolean;
    openRecorder: () => void;
    closeRecorder: () => void;
};

export const AudioRecordingContext = React.createContext<AudioRecordingContextProps>({
    isRecorderOpen: false,
    openRecorder: () => {},
    closeRecorder: () => {},
});

export type AudioRecordingContainerProps = AudioRecordingContainerOwnProps;

const hiddenStyle: StyleProp<ViewStyle> = {
    display: 'none',
    width: 0,
    height: 0,
};

const visibleStyle: StyleProp<ViewStyle> = {
    width: '100%',
    height: '100%',
};

export const audioRecordingPortalName = 'audio-recording-portal';

const AudioRecordingContainer: React.FC<AudioRecordingContainerProps> = (props) => {
    const [isRecordingOpen, setIsRecordingOpen] = React.useState(false);
    const audioRecordingContextValue = React.useMemo<AudioRecordingContextProps>(
        () => ({
            isRecorderOpen: isRecordingOpen,
            openRecorder: () => setIsRecordingOpen(true),
            closeRecorder: () => setIsRecordingOpen(false),
        }),
        [isRecordingOpen],
    );

    return (
        <AudioRecordingContext.Provider value={audioRecordingContextValue}>
            <View style={props.style}>
                <View
                    style={[isRecordingOpen ? visibleStyle : hiddenStyle, { backgroundColor: colors.White }]}
                    collapsable={false}
                >
                    <PortalHost name={audioRecordingPortalName} />
                </View>
                <View style={[isRecordingOpen ? hiddenStyle : visibleStyle]} collapsable={false}>
                    {props.children}
                </View>
            </View>
        </AudioRecordingContext.Provider>
    );
};

export default React.memo(AudioRecordingContainer);
